{
  "version": 1,
  "asset_id": "cc1ee675-7463-4b95-9539-33f2938fab6e",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/cc1ee675-7463-4b95-9539-33f2938fab6e/rth.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/cc1ee675-7463-4b95-9539-33f2938fab6e/rth.png",
  "original_filename": "rth.png",
  "size": 567849,
  "content_type": "image/png",
  "created_at": "2026-06-25T00:53:51Z"
}
